import getStore from '../store/Store';
import { action, mutator } from 'satcheljs';
import { ObservableMap } from 'mobx';
import getUrlOverrides from '../utils/overrides/getUrlOverrides';
import { setLogicalRing } from 'owa-config/lib/getLogicalRing';
import calculateLogicalRing from '../utils/calculateLogicalRing';
import { getLocalStorageOverrides } from '../utils/overrides/localStorageOverrides';

export const FEATURES_QUERYSTRING_PARAMETER_NAME = 'features';
export const FLIGHT_DEVTOOLS_NAME = 'fwk-devtools';

export interface InitializeState {
    featureFlags: ObservableMap<string, boolean>;
    defaultFlags: ObservableMap<string, boolean>;
}

const initializeFeatureFlags = action('initializeFeatureFlags', (flagsFromService?: string[]) => {
    const enabledFlagsFromService = flagsFromService || [];
    const flagsFromServiceObject = {};
    enabledFlagsFromService.forEach(
        flagFromService => (flagsFromServiceObject[flagFromService.toLowerCase()] = true)
    );

    // Apply overrides from local storage and query
    const flags = {
        ...flagsFromServiceObject,
        ...getLocalStorageOverrides(),
        ...(flagsFromServiceObject[FLIGHT_DEVTOOLS_NAME]
            ? getUrlOverrides(FEATURES_QUERYSTRING_PARAMETER_NAME)
            : {}),
    };

    return { enabledFlagsFromService, initialFlagsWithOverrides: flags };
});

mutator(initializeFeatureFlags, ({ enabledFlagsFromService, initialFlagsWithOverrides }) => {
    // Apply defaults from the service
    enabledFlagsFromService.forEach(featureName => {
        getStore().defaultFlags.set(featureName.toLowerCase(), true);
    });

    // Apply initial state w/ calculated overrides
    Object.keys(initialFlagsWithOverrides).forEach(featureName => {
        getStore().featureFlags.set(
            featureName.toLowerCase(),
            initialFlagsWithOverrides[featureName]
        );
    });

    setLogicalRing(calculateLogicalRing());
});

export default initializeFeatureFlags;
